import { Directive, HostListener, NgZone } from '@angular/core';
import { Subscription, timer } from 'rxjs';
import { AuthGuard } from '../authGuardClass';

@Directive({
  selector: '[appMousemoveDetector]'
})
export class MousemoveDetectorDirective {
  private timerSubscription: Subscription | null = null; // Initialize with null
  private timeInMinutes = 15;

  constructor(private authGuard: AuthGuard, private zone: NgZone) {
    this.resetTimeout(); // Start initial timer
  }

  @HostListener('document:mousemove', ['$event'])
  onMouseMove(event: MouseEvent) {

    this.resetTimeout();  // Reset timeout on mouse move
  }

  private resetTimeout() {
    // Unsubscribe from the previous timer (if any)
    if (this.timerSubscription) {

      this.timerSubscription.unsubscribe();
    }

    // Start a new timer
    this.timerSubscription = timer(this.timeInMinutes * 60 * 1000).subscribe(() => {
      this.zone.run(() => {
        this.authGuard.logOut();
      });
    });
  }
}
